const MONTHS = ["", "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

export const fmtInt = (n) => (n == null ? "—" : Math.round(n).toLocaleString("de-DE"));
export const fmtNum = (n, d = 1) =>
  n == null ? "—" : Number(n).toLocaleString("de-DE", { maximumFractionDigits: d });
export const fmtGBP = (n) => (n == null ? "—" : "£" + Math.round(n).toLocaleString("de-DE"));
export const fmtGBP2 = (n) =>
  n == null ? "—" : "£" + Number(n).toLocaleString("de-DE", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
export const fmtPct = (n) => (n == null ? "—" : n + "%");

export const monthLabel = (m) => {
  if (!m) return "";
  const [y, mo] = m.split("-");
  return `${MONTHS[+mo]} '${y.slice(2)}`;
};

export const formatApiErrorDetail = (detail) => {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
};

export const CHART = {
  sea: "hsl(var(--chart-1))",
  air: "hsl(var(--chart-2))",
  road: "hsl(var(--chart-3))",
  lcl: "hsl(var(--chart-4))",
  cfs: "hsl(var(--chart-5))",
  brand: "hsl(var(--brand))",
  ok: "hsl(152 76% 36%)",
  warn: "hsl(43 96% 46%)",
  bad: "hsl(0 84% 55%)",
};

export const tooltipStyle = {
  background: "hsl(var(--popover))",
  border: "1px solid hsl(var(--border))",
  borderRadius: 4,
  fontSize: 12,
  fontFamily: "JetBrains Mono, monospace",
  color: "hsl(var(--popover-foreground))",
};
